import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxBorder, Color, Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

import { getUrlParam } from '../../../utils/getUrlParam';

export interface MasterProfileProps {
  isMobile?: boolean;
}

export const MasterProfile: React.FC<MasterProfileProps> = ({ isMobile = false }) => {
  const isMaster = getUrlParam('isMaster', 'false') === 'true';

  if (!isMaster) {
    return <></>;
  }

  if (isMobile) {
    return <UI.Icon name="IdCard" size="xxs" color={Color['brand.tertiary.principal']} />;
  }

  return (
    <Stack
      borderRadius={BoxBorder.heavy}
      bgColor={Color['neutral.white']}
      px={Spacing['inline.xxxs']}
      py={Spacing['stack.nano']}>
      <VStack space={Spacing['stack.quarck']}>
        <HStack alignItems="center" space={Spacing['inline.quarck']}>
          <UI.Icon name="IdCard" size="xxs" color={Color['brand.tertiary.principal']} />
          <UI.Text color="neutral.medium" fontSize={Typography['fontsize.xs']}>
            Perfil de acesso
          </UI.Text>
        </HStack>
        <UI.Text variant="semibold">MASTER PARCEIRO</UI.Text>
      </VStack>
    </Stack>
  );
};
